import { TypographyH1 } from "@/components/ui/typography"
import { SUPPORT_EMAIL } from "@/shared/constants/basic"
import { useAutoTranslation } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"

import styles from "./styles.module.scss"

export const ContactUsPage = () => {
  const { t } = useAutoTranslation()

  return (
    <div className={styles.page}>
      <TypographyH1 className="mb-2">
        {t(DISCOVERED_TRANSLATION_KEYS.CONTACT_US)}
      </TypographyH1>

      <h3>
        {t(
          DISCOVERED_TRANSLATION_KEYS.WE_ARE_OPEN_TO_HELP_YOU_WITH_ANY_QUESTIONS_OR_SUPPORT
        )}
      </h3>

      <h3>
        {t(
          DISCOVERED_TRANSLATION_KEYS.FOR_QUESTIONS_SUGGESTIONS_OR_JUST_TO_SAY_HELLO_REACH_OUT_VIA_THE_SUPPORT_EMAIL_BELOW
        )}
      </h3>

      <p>
        {t(DISCOVERED_TRANSLATION_KEYS.SUPPORT_EMAIL)}{" "}
        <a className={styles.email} href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </p>
    </div>
  )
}
